/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { cn, Empty, EmptyHeader, EmptyMedia, EmptyTitle } from "@farmlands/shadcn-ui";
import { LottieOptions, useLottie } from "lottie-react";
import { FC, JSX, ReactNode } from "react";

import TractorLottie from "../../../../../assets/lottie/Tractor.json";

export interface TruckLoadingLayoutProps {
  className?: string;
  message?: ReactNode;
}

export const TruckLoadingLayout: FC<TruckLoadingLayoutProps> = ({
  className,
  message = <p>Loading...</p>,
}): JSX.Element => {
  const { View } = useLottie({
    animationData: TractorLottie,
    loop: true,
  } satisfies LottieOptions<"svg">);

  return (
    <Empty className={cn("w-full gap-4 p-4 py-8 md:py-16", className)}>
      <EmptyHeader className="w-full max-w-125">
        <EmptyMedia variant="icon" className="rounded-sm md:p-2">
          <div
            className={`
              flex size-20 items-center justify-center
              [&>div]:flex [&>div]:items-center [&>div]:justify-center
            `}
          >
            {View}
          </div>
        </EmptyMedia>

        {!!message && <EmptyTitle className="text-lg">{message}</EmptyTitle>}
      </EmptyHeader>
    </Empty>
  );
};
